export const CHART_COLORS = [
  "#1976D2",
  "#D32F2F",
  "#388E3C",
  "#F57C00",
  "#7B1FA2",
  "#00796B",
  "#303F9F",
  "#C2185B",
  "#455A64",
  "#689F38",
];

export function chartColorAt(index) {
  const i = Number.isFinite(Number(index)) ? Math.abs(Math.floor(index)) : 0;
  return CHART_COLORS[i % CHART_COLORS.length];
}
